import React from 'react';

interface Tab {
    key: string;
    label: string;
}

interface DeductionTabsProps {
    tabs: Tab[];
    activeTab: string;
    onTabChange: (tabKey: string) => void;
}

const DeductionTabs: React.FC<DeductionTabsProps> = ({ tabs, activeTab, onTabChange }) => {
    return (
        <div className="deduction-tabs-container">
            {tabs.map((tab) => (
                <button
                    key={tab.key}
                    className={`deduction-tab ${activeTab === tab.key ? 'active' : ''}`}
                    onClick={() => onTabChange(tab.key)}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
};

export default DeductionTabs;
